import { Auth } from 'aws-amplify';

// Types
export interface AuthConfig {
  userPoolId: string;
  region: string;
  userPoolWebClientId: string;
  oauth?: {
    domain: string;
    scope: string[];
    redirectSignIn: string;
    redirectSignOut: string;
    responseType: string;
  };
}

export interface AwsConfig {
  Auth: AuthConfig;
  API: {
    endpoints: Array<{
      name: string;
      endpoint: string;
      custom_header?: () => Promise<{ [key: string]: string }>;
    }>;
  };
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const stageEnv = process.env.REACT_APP_STAGE || 'dev';
const APP_URL = process.env.REACT_APP_URL || 'http://localhost:3000';
const COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || '';
const REGION = process.env.REACT_APP_REGION || 'us-west-1';
const USER_POOL_WEBCLIENT_ID = process.env.REACT_APP_USER_POOL_WEBCLIENT_ID || 'dummy-client-id';

// console.log('Auth::::',Auth.currentSession())
console.log("stageEnv",stageEnv);


// Define auth configurations
const devAuthConfig = {
  userPoolId: 'eu-north-1_qeAyHnbo4',
  region: REGION,
  userPoolWebClientId: '3k6hf29uop4vluep2b1o0fj146'
};

const demoAuthConfig = {
  userPoolId: 'us-west-1_vXOMoAJfx',
  region: REGION,
  userPoolWebClientId: USER_POOL_WEBCLIENT_ID,
  oauth: {
    domain: COGNITO_DOMAIN,
    scope: ['email', 'profile', 'openid'],
    redirectSignIn: `${APP_URL}/upload`,
    redirectSignOut: `${APP_URL}/login`,
    responseType: 'code'
  }
};

let authConfig;

if (stageEnv === 'dev') {
  authConfig = { ...devAuthConfig };
} else if (stageEnv === 'demo') {
  authConfig = { ...demoAuthConfig };
} else {
  authConfig = { ...devAuthConfig };
}

// Use the consolidated authConfig for cognitoPool
export const cognitoPool = { auth: authConfig };

const dev: AwsConfig = {
  Auth: devAuthConfig,
  API: {
    endpoints: [
      {
        name: 'no-auth',
        endpoint: API_BASE_URL,
        // custom_header: async (): Promise<{ [key: string]: string }> => {
        //   try {
        //     const session = await Auth.currentSession();
        //     return { Authorization: `Bearer ${session.getIdToken().getJwtToken()}` };
        //   } catch (error) {
        //     console.error('Error getting auth token:', error);
        //     return { Authorization: '' }; // Return an object with an empty string instead of undefined
        //   }
        // }
      },
      {
        name: 'droneftp-service',
        endpoint: API_BASE_URL,
        custom_header: async () => {
          try {
            const session = await Auth.currentSession();
            return {
              Authorization: `Bearer ${session.getIdToken().getJwtToken()}`
            };
          } catch (error) {
            console.error('Error getting auth token:', error);
            return { Authorization: '' };
          }
        }
      }
    ]
  }
};

const demo: AwsConfig = {
  Auth: demoAuthConfig,
  API: {
    endpoints: [
      {
        name: 'no-auth',
        endpoint: API_BASE_URL
      },
      {
        name: 'leardon-service',
        endpoint: API_BASE_URL,
        custom_header: async (): Promise<{ [key: string]: string }> => {
          try {
            const session = await Auth.currentSession();
            return { Authorization: `Bearer ${session.getIdToken().getJwtToken()}` };
          } catch (error) {
            console.error('Error getting auth token:', error);
            return { Authorization: '' }; // Return an object with an empty string instead of undefined
          }
        }
      }
    ]
  }
};

const awsConfig: AwsConfig = stageEnv === 'demo' ? { ...demo } : { ...dev };

export default awsConfig;
